import React from "react";
import { Search, X } from "lucide-react";

/**
 * AdminListSearch — small inline search input for admin list pages.
 * Renders a rounded pill with search icon + optional clear button.
 */
export default function AdminListSearch({ value, onChange, placeholder = "Search…", testId = "admin-list-search", count }) {
  return (
    <div className="mb-4 flex items-center gap-2 flex-wrap">
      <div className="flex items-center gap-2 flex-1 min-w-[240px] max-w-xl px-3 py-2 border border-navy/15 rounded-md bg-white">
        <Search size={14} className="text-ink-muted flex-shrink-0" />
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 bg-transparent text-sm outline-none placeholder:text-ink-faint text-ink"
          data-testid={testId}
        />
        {value && (
          <button
            onClick={() => onChange("")}
            className="text-ink-muted hover:text-rose-600"
            title="Clear"
            data-testid={`${testId}-clear`}
          >
            <X size={12} />
          </button>
        )}
      </div>
      {typeof count === "number" && (
        <span className="text-[10px] font-mono uppercase tracking-widest text-ink-muted">
          {count} result{count === 1 ? "" : "s"}
        </span>
      )}
    </div>
  );
}

/**
 * Filter a list of rows by matching a query against the fields returned by
 * `getFields(row)`. Case-insensitive substring match.
 */
export function useAdminSearch(rows, getFields, query) {
  return React.useMemo(() => {
    const q = (query || "").trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((r) => {
      const hay = getFields(r).filter(Boolean).join(" ").toLowerCase();
      return hay.includes(q);
    });
  }, [rows, getFields, query]);
}
